export default "__VITE_ASSET__9DtPnGFE__"